console.log('index template')